import * as React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

interface SwitchOption {
  value: string;
  label: string;
}

interface Props {
  options: SwitchOption[];
  onChange: (value: string | null) => void;
  value?: string;
}

export default class FilterSwitchGroup extends React.PureComponent<Props> {
  handleChangeFor = (value: string) => (
    _: React.ChangeEvent<{}>,
    checked: boolean,
  ) => {
    const { onChange } = this.props;

    onChange(checked ? value : null);
  };

  render() {
    const { value: selectedValue, options } = this.props;

    return options.map(({ value, label, ...rest }) => (
      <div key={value}>
        <FormControlLabel
          control={
            <Switch
              color="primary"
              checked={value === selectedValue}
              onChange={this.handleChangeFor(value)}
              value={value}
            />
          }
          label={label}
          {...rest}
        />
      </div>
    ));
  }
}
